/**
 * 页面组件的引入
 */
export default {
  use: (Vue, Router, loadLanguageAsync) => {
    Vue.use(Router)
    const { routerPreFix } = require('$proDirname/prefix')
    //  设置 spa 的路由前缀
    const prefix = window?.ssrConfig?.routerConfig?.name ?? `/${routerPreFix.superMerchantV1}/index`;
    const router = new Router({
      mode: 'history',
      prefix,
      routes: [
        {
          path: `*`,
          redirect: `${prefix}/legal-policies`
        },
        {
          name: 'legal-policies',
          path: `${prefix}/legal-policies`,
          component: () => import('./legal-policies')
        },
        {
          name: 'help-center',
          path: `${prefix}/help-center`,
          component: () => import('./help-center')
        },
        {
          name: 'special-legal-policies',
          path: `${prefix}/special-legal-policies`,
          component: () => import('./special-legal-policies')
        },
      ]
    });
    //  路由切换懒加载对应的国家化文案
    router.beforeEach((to, from, next) => {
      loadLanguageAsync({
        router: to.name
      }).then(() => next()).catch(() => next());
    })
    return router;
  }
}